import styled from 'styled-components';
export const FileContainer = styled.div `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 5px;
`;
export const FileIcon = styled.img ``;
export const FileImage = styled.img `
  max-width: 250px;
  max-height: 500px;
  border-radius: 8px;
  object-fit: cover;
  background: #f0f0f0;
`;
export const FileLink = styled.a `
  max-width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
